export const colors = {
  white: '#FFFFFF',
  mainColor: '#111111',
  accentColor: '#7065F0',
  bodyTextColor: '#333333',
  imageBackground: '#F6F8FB',
  transparent: 'transparent',
  secondaryTextColor: '#7065F0',
  darkTextColor: '#000000',
};

export const theme = { colors };
